<div class="layout-container" [class.layout--collapsed]="sidebarCollapsed()">
  <dime-sidebar [collapsed]="sidebarCollapsed()" />

  <div class="content-container">
    <dime-toolbar (menuToggle)="onMenuToggle()" />

    <main class="page-wrapper">
      <router-outlet />
    </main>
  </div>
</div>
